import {
  INICIALITZAR,
  OBTENIR_DADES_CREACIO_INDIVIDU
} from "../actions/actionTypes";

const ESTAT_INICIAL = {};

const subEspecies = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INICIALITZAR:
      return ESTAT_INICIAL;

    case `${OBTENIR_DADES_CREACIO_INDIVIDU}_SUCCESS`:
      return action.payload.subEspecies;
    default:
      return state;
  }
};

export default subEspecies;

const totesSubEspecies = state => state.subEspecies;

export const getSubEspecies = state => {
  const subEspecies = totesSubEspecies(state);

  if (!subEspecies) {
    return null;
  }
  return subEspecies;
};
